import styled from 'styled-components'

export const BtnContainer = styled.div`
    position: absolute;
    bottom: 0px;
    left: 0px;
    padding: 32px 24px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0 0 32px 32px;
    background-image: linear-gradient(rgba(255,255,254,0), rgba(255,255,253,1), rgba(255,255,255,1));
`

const Button = styled.button`
    width: 100%;
    background-color: ${(props) => props.isLoading ? '#7FBFFF' : '#0080FF'};
    color: white;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    outline: none;
    border: none;
    border-radius: 4px;
    transition: background-color 300ms;
`

export default Button